interface ScorePadPlayer {
  readonly playerId: string;
  readonly name: string;
}

interface ScorePadProps {
  readonly players: readonly ScorePadPlayer[];
  readonly scoreHistoryByPlayerId: Readonly<Record<string, readonly number[]>>;
  readonly winnerIds?: readonly string[] | null;
  readonly totalRounds?: number;
}

export function ScorePad({
  players,
  scoreHistoryByPlayerId,
  winnerIds,
  totalRounds = 7,
}: ScorePadProps) {
  return (
    <div
      className="overflow-x-auto rounded-md border border-border-subtle bg-surface-secondary p-2"
      data-testid="carnival-of-sins-score-pad"
    >
      <table className="cos-score-pad">
        <thead>
          <tr>
            <th>Player</th>
            {Array.from({ length: totalRounds }, (_unused, i) => (
              <th key={i}>{`R${i + 1}`}</th>
            ))}
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          {players.map((player) => {
            const history = scoreHistoryByPlayerId[player.playerId] ?? [];
            const total = history.reduce((sum, score) => sum + score, 0);
            const isWinner = (winnerIds ?? []).includes(player.playerId);
            return (
              <tr key={player.playerId} data-winner={isWinner}>
                <td className="name">{player.name}</td>
                {Array.from({ length: totalRounds }, (_unused, i) => (
                  <td
                    key={i}
                    className={(history[i] ?? 0) < 0 ? "negative" : undefined}
                  >
                    {history[i] ?? "–"}
                  </td>
                ))}
                <td className="total">{total}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
